/**
 * Account API - web-only account management (e.g. deregistration).
 */
import api from '../utils/api';
import { ENDPOINTS } from '../config/endpoints';

const { ACCOUNT } = ENDPOINTS;

export const deregisterAccount = (mobile, reqId, otp) =>
  api.post(ACCOUNT.DEREGISTER, { mobile, reqId, otp });
